// reducers/commonReducer.js
import { UPDATE_NOTIFICATION, CLEAR_NOTIFICATION } from "../constants/common";

const initialNotification = {
    message: "",
    severity: "info", // "success" | "error" | "warning" | "info"
    duration: 3000,
    version: 0, // to trigger with same values
};

export const updateNotificationReducer = (state = initialNotification, action) => {
    switch (action.type) {
        case UPDATE_NOTIFICATION:
            return {
                ...state,
                ...action.payload,
                version: state.version + 1,
            };
        case CLEAR_NOTIFICATION:
            return initialNotification;
        default:
            return state;
    }
};
